import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { SITE } from "../lib/data";

const LegalLayout = ({ title, children, testId }) => (
  <main data-testid={testId} className="mx-auto max-w-3xl px-5 py-24 lg:py-32">
    <Reveal>
      <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
      <div className="mt-10 space-y-6 text-sm leading-relaxed text-mist md:text-base">{children}</div>
      <p className="mt-12 text-sm">
        <Link to="/contact" className="text-ember underline" data-testid={`${testId}-contact-link`}>
          Contact us
        </Link>{" "}
        <span className="text-mist">with any questions.</span>
      </p>
    </Reveal>
  </main>
);

export const Privacy = () => (
  <LegalLayout title="Privacy Policy" testId="privacy-page">
    <Seo title="Privacy Policy | Petroline Services" description="How Petroline Services handles information submitted through this website." />
    <p>
      Petroline Services ("we", "us") respects your privacy. This policy explains how we handle
      information submitted through this website.
    </p>
    <p>
      <strong className="text-coal">Information we collect.</strong> When you submit our contact
      form, we collect the details you provide: your name, company, phone number, email address,
      property location, the service requested and your message.
    </p>
    <p>
      <strong className="text-coal">How we use it.</strong> We use this information only to
      respond to your inquiry and to discuss the services you requested. We do not sell, rent or
      share your personal information with third parties for marketing purposes.
    </p>
    <p>
      <strong className="text-coal">Retention.</strong> Inquiry details are retained only as long
      as needed to respond to and manage your request.
    </p>
    <p>
      <strong className="text-coal">Contact.</strong> Questions about this policy can be directed
      to us at {SITE.phone} or by mail at {SITE.addressLine1}, {SITE.addressLine2}.
    </p>
  </LegalLayout>
);

export const Terms = () => (
  <LegalLayout title="Terms of Service" testId="terms-page">
    <Seo title="Terms of Service | Petroline Services" description="Terms governing the use of the Petroline Services website." />
    <p>
      By using this website, you agree to the following terms. The content on this site is
      provided for general information about Petroline Services and the commercial contracting
      and facility-maintenance services we offer.
    </p>
    <p>
      <strong className="text-coal">No quote or agreement.</strong> Submitting a contact form or
      using this website does not create a service agreement. Any work is subject to a separate
      written quote or contract.
    </p>
    <p>
      <strong className="text-coal">Accuracy.</strong> We aim to keep the information on this
      site accurate and current, but make no warranties about completeness. Imagery on this site
      is representative of the types of commercial environments we service.
    </p>
    <p>
      <strong className="text-coal">Intellectual property.</strong> The content, design and
      branding of this website belong to Petroline Services and may not be reproduced without
      permission.
    </p>
    <p>
      <strong className="text-coal">Contact.</strong> Questions about these terms can be directed
      to us at {SITE.phone} or by mail at {SITE.addressLine1}, {SITE.addressLine2}.
    </p>
  </LegalLayout>
);
